import { Button, Center, Container, Input, Flex, Checkbox, Spacer, HStack, Table, Thead, Tbody, Th, Tr, Td, Divider} from '@chakra-ui/react'
import React from 'react'

const FAKE_DATASET = [{
    user_id: "User",
    timestamp: "Timestamp00:00:00",
    qualtrics_id: "Prolific ID",
    is_mobile: false,
    image_url: "website dot com",
    filter_used: "Name of Filter",
    response: "Response given to survey question",
    is_completed: true
}, {
    user_id: "User2",
    timestamp: "Timestamp200:00:00",
    qualtrics_id: "Prolific ID 2",
    is_mobile: false,
    image_url: "website2 dot com",
    filter_used: "Name of Filter 2",
    response: "Another response given to survey question",
    is_completed: true
}]

const ResultsPage = () => {
  return (
    <Container maxW={'container.xl'}>

            <Input marginTop={'40px'} marginBottom={'16px'} placeholder='Input Query...' />
            <Flex spacing={'16px'} justifyContent={'space-between'}>
                {/*TODO: Make these controls do what they are supposed to*/}
                <Checkbox colorScheme='blue'>Include Test IDs</Checkbox>
                <Spacer/>
                <HStack>
                    <Button colorScheme='blue'>Count Rows</Button>
                    <Button colorScheme='blue'>Refresh</Button>
                    <Button colorScheme='blue'>Export</Button>
                </HStack>
            </Flex>
            <Divider margin={'16px'}/>
            {/*TODO: Table sorting*/}
            <Table>
                <Thead>
                    <Tr>
                        <Th>User ID</Th>
                        <Th>Timestamp</Th>
                        <Th>Qualtrics ID</Th>
                        <Th>On Mobile?</Th>
                        <Th>Image URL</Th>
                        <Th>Filter Used</Th>
                        <Th>Response</Th>
                        <Th>Completed?</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {FAKE_DATASET.map((entry) => (
                        <Tr>
                            <Td>{entry.user_id}</Td>
                            <Td>{entry.timestamp}</Td>
                            <Td>{entry.qualtrics_id}</Td>
                            <Td>{entry.is_mobile.toString()}</Td>
                            <Td>{entry.image_url}</Td>
                            <Td>{entry.filter_used}</Td>
                            <Td>{entry.response}</Td>
                            <Td>{entry.is_completed.toString()}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>

    </Container>
  )
}

export default ResultsPage
